module.exports = __webpack_public_path__ + "static/img/topbanner-07.33e6429.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides_banner/topbanner-07.jpg
// module id = CMzY
// module chunks = 0